import { render, staticRenderFns } from "./GameSummary.vue?vue&type=template&id=19cc1da7&lang=pug"
import script from "./GameSummary.vue?vue&type=script&lang=js"
export * from "./GameSummary.vue?vue&type=script&lang=js"
import style0 from "./GameSummary.vue?vue&type=style&index=0&id=19cc1da7&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports